module.exports = __webpack_public_path__ + "static/media/screenshot-dropbox.71c20fb8.jpg";